// O convite "Cadastre sua OAB" é estado, não reexibição periódica: gravar a
// profissão zera `is_eligible`, então o backend responde `should_show_banner`
// false para sempre nesse modo e a única fonte de adiamento é o × do próprio
// convite. Gatear pelo `lastShownAt` (como fazia o espelho da cadência do M1)
// silenciava por 7 dias justamente quem tinha acabado de se declarar advogado,
// porque a exibição da pergunta já havia regravado o timestamp segundos antes.
//
// Teto: o adiamento é por device, porque o PATCH de preferências é `.strict()`
// e não aceita chave nova. Se precisar valer na conta, o M1 (FT-910) expõe uma
// chave de dispensa e este arquivo morre junto com a leitura no banner.
const STORAGE_KEY = 'oabCaptureInvitePostponedAt';
const POSTPONE_DAYS = 7;
const DAY_IN_MS = 24 * 60 * 60 * 1000;

const keyFor = (userId?: number): string =>
  `${STORAGE_KEY}:${userId ?? 'anon'}`;

export function isInvitePostponed(
  userId?: number,
  now: Date = new Date(),
): boolean {
  try {
    const postponedAt = window.localStorage.getItem(keyFor(userId));

    if (!postponedAt) {
      return false;
    }

    // Valor corrompido dá NaN, e NaN reprova as duas comparações: o convite
    // volta a aparecer, que é o lado seguro de errar. `elapsed < 0` cobre o
    // relógio do device voltando no tempo depois do adiamento — sem o piso,
    // o adiamento duraria até `postponedAt + 7 dias`, que pode passar muito
    // dos 7 dias pretendidos.
    const elapsed = now.getTime() - new Date(postponedAt).getTime();

    return elapsed >= 0 && elapsed < POSTPONE_DAYS * DAY_IN_MS;
  } catch {
    return false;
  }
}

export function postponeInvite(userId?: number): void {
  try {
    window.localStorage.setItem(keyFor(userId), new Date().toISOString());
  } catch {
    /* sessão sem storage: o adiamento degrada para "até o refresh" */
  }
}
